import { type AbstractControl, type ValidatorFn, type ValidationErrors } from '@angular/forms';

export function accountNicknameValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value) {
      const nicknamePattern = /^[A-Za-z0-9 - ' _ . ]*$/;
      const nicknamePatternSpacesOnly = /^[ ]*$/;
      if (!nicknamePattern.test(value)) {
        return { invalidCharacters: true };
      }
      if (value.length > 0 && nicknamePatternSpacesOnly.test(value)) {
        return { invalidCharacters: true };
      }
    }
    return null;
  };
}
